import { TokenImage } from '@/components/common/tokenImage'
import type { BorrowMarketRow } from '@/hooks/useBorrowMarkets'
import { cn } from '@/utils/cn'

interface BorrowMarketsCollateralProps {
  assets: BorrowMarketRow['collateralAssets']
  className?: string
  iconClassName?: string
  maxVisibleAssets?: number
}

const MAX_VISIBLE_COLLATERAL_ASSETS = 5

export const BorrowMarketsCollateral = ({
  assets,
  className,
  iconClassName,
  maxVisibleAssets = MAX_VISIBLE_COLLATERAL_ASSETS,
}: BorrowMarketsCollateralProps) => {
  if (assets.length === 0) return <span className="text-caption">--</span>

  const visibleAssets = assets.slice(0, maxVisibleAssets)
  const hiddenAssetsCount = assets.length - visibleAssets.length

  return (
    <div className={cn('flex items-center', className)}>
      <div className="-space-x-2 flex items-center">
        {visibleAssets.map(({ asset }) => (
          <TokenImage
            key={`${asset.address}-${asset.symbol}`}
            symbol={asset.symbol}
            className={cn('size-8 p-1 group-even:bg-page', iconClassName)}
          />
        ))}
      </div>
      {hiddenAssetsCount > 0 && (
        <span className="ml-2 whitespace-nowrap font-medium text-caption text-xs">+{hiddenAssetsCount}</span>
      )}
    </div>
  )
}
